import React, { useEffect, useState } from "react";
import {
  Breadcrumb,
  Row,
  Col,
  Card,
  Space,
  Button,
  Modal,
  notification,
} from "antd";

import { Table } from "ant-table-extensions";
import { ExclamationCircleOutlined } from "@ant-design/icons";
import { useMediaQuery } from "react-responsive";

import Create from "./Create";
import Edit from "./Edit";
import Ordering from "./Ordering";

import axios from "axios";
import urldata from "../../../../urldata";
import config from "../../../../config/config";

const { confirm } = Modal;

function Index() {
  const isMobile = useMediaQuery({ query: "(max-width: 576px)" });

  const [btnSize, setBtnSize] = useState("middle");
  const [datas, setDatas] = useState([]);
  const [loading, setLoading] = useState(false);

  const [createOpen, setCreateOpen] = useState(false);
  const [createKey, setCreateKey] = useState(1);

  const [editOpen, setEditOpen] = useState(false);
  const [editKey, setEditKey] = useState(1);
  const [selectedRecord, setSelectedRecord] = useState(null);

  const [orderOpen, setOrderOpen] = useState(false);

  const moduleName = "Catalogue";
  const moduleNamePlural = "Catalogue";

  const base_api = urldata + "admin/catalog";
  const azure_base = config.azure_object_url || "";

  // ---------------------------
  // Fetch Data
  // ---------------------------
  const fetchDatas = async () => {
    setLoading(true);

    try {
      const response = await axios.get(base_api);

      const list =
        response?.data?.data && Array.isArray(response.data.data)
          ? response.data.data
          : [];

      setDatas(list);

      if (!list.length) {
        notification.info({ message: "No Catalogue found" });
      }
    } catch (err) {
      console.error(err);
      notification.error({ message: "Failed to fetch Catalogue" });
      setDatas([]);
    } finally {
      setLoading(false);
    }
  };

  useEffect(() => {
    fetchDatas();
  }, []);

  useEffect(() => {
    setBtnSize(isMobile ? "small" : "middle");
  }, [isMobile]);

  // ---------------------------
  // Create Handlers
  // ---------------------------
  const handleCreateOpen = () => setCreateOpen(true);

  const handleCreateClose = (refresh = false) => {
    setCreateKey((k) => k + 1);
    setCreateOpen(false);
    if (refresh) fetchDatas();
  };

  // ---------------------------
  // Edit Handlers
  // ---------------------------
  const handleEditOpen = (record) => {
    setSelectedRecord(record);
    setEditOpen(true);
  };

  const handleEditClose = (refresh = false) => {
    setEditKey((k) => k + 1);
    setSelectedRecord(null);
    setEditOpen(false);
    if (refresh) fetchDatas();
  };

  // ---------------------------
  // Delete Handler
  // ---------------------------
  const handleDelete = (record) => {
    confirm({
      title: `Are you sure you want to delete this ${moduleName}?`,
      icon: <ExclamationCircleOutlined />,
      okText: "Yes",
      okType: "danger",
      cancelText: "No",

      async onOk() {
        try {
          await axios.delete(`${base_api}/${record._id}`);

          notification.success({
            message: `${moduleName} deleted successfully`,
          });

          fetchDatas();
        } catch (err) {
          notification.error({ message: "Failed to delete" });
        }
      },
    });
  };

  // ---------------------------
  // Table Columns
  // ---------------------------
  const columns = [
    {
      title: "Name",
      dataIndex: "name",
      key: "name",
    },
    {
      title: "PDF",
      key: "catelog",
      render: (_, record) => (
        <a
          href={azure_base + "/public/uploads/catalog/" + record.catelog}
          target="_blank"
          rel="noreferrer"
        >
          View PDF
        </a>
      ),
    },
    {
      title: "Action",
      key: "action",
      render: (_, record) => (
        <Space size="middle">
          <Button
            type="primary"
            size={btnSize}
            onClick={() => handleEditOpen(record)}
          >
            Edit
          </Button>

          <Button danger size={btnSize} onClick={() => handleDelete(record)}>
            Delete
          </Button>
        </Space>
      ),
    },
  ];

  return (
    <div>
      <Breadcrumb style={{ margin: "16px 0" }}>
        <Breadcrumb.Item>Dashboard</Breadcrumb.Item>
        <Breadcrumb.Item>{moduleNamePlural}</Breadcrumb.Item>
      </Breadcrumb>

      <Row>
        <Col span={24}>
          <Card title={moduleNamePlural} bordered={false}>
            <Row style={{ marginBottom: 20 }}>
              <Col span={24}>
                <Space>
                  <Button
                    type="primary"
                    size={btnSize}
                    onClick={handleCreateOpen}
                  >
                    Add {moduleName}
                  </Button>

                  <Button
                    type="primary"
                    size={btnSize}
                    onClick={() => setOrderOpen(true)}
                  >
                    View Ordering
                  </Button>
                </Space>
              </Col>
            </Row>

            <Table
              loading={loading}
              rowKey={(record) => record._id}
              columns={columns}
              dataSource={datas}
              footer={() => `Total ${moduleNamePlural} = ${datas.length}`}
            />

            {/* CREATE */}
            <Create
              key={"create" + createKey}
              isVisible={createOpen}
              handleClose={handleCreateClose}
              moduleName={moduleName}
              base_url={base_api}
            />

            {/* EDIT */}
            {selectedRecord && (
              <Edit
                key={"edit" + editKey}
                isVisible={editOpen}
                handleClose={handleEditClose}
                moduleName={moduleName}
                base_url={base_api}
                record={selectedRecord}
                azure_base={azure_base}
              />
            )}

            {/* ORDERING */}
            <Ordering
              isOpen={orderOpen}
              datas={datas}
              moduleName={moduleName}
              base_url={base_api}
              onClose={(updatedList) => {
                setOrderOpen(false);

                if (updatedList) {
                  setDatas(updatedList);
                } else {
                  fetchDatas();
                }
              }}
            />
          </Card>
        </Col>
      </Row>
    </div>
  );
}

export default Index;
